<div class="modal-header">
  <h4 class="modal-title">
    {{ selectedServiceCharge ? 'Edit' : 'Add' }} Service Charge
  </h4>
  <button type="button" class="btn-close" (click)="dismissModal()"></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-6">
        <div class="mb-3">
          <label for="id" class="form-label">ID</label>
          <input
            [ngClass]="{
              disabled: !!selectedServiceCharge,
              'invalid-input':
                form.get('id')?.invalid && form.get('id')?.touched,
            }"
            type="text"
            class="form-control"
            id="id"
            formControlName="id" />
          <span
            class="small error-color"
            *ngIf="form.get('id')?.invalid && form.get('id')?.touched">
            ID is required
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label for="name" class="form-label">Name</label>
          <input
            type="text"
            class="form-control"
            id="name"
            [ngClass]="{
              'invalid-input':
                form.get('name')?.invalid && form.get('name')?.touched,
            }"
            formControlName="name" />
          <span
            class="small error-color"
            *ngIf="form.get('name')?.invalid && form.get('name')?.touched">
            Name is required
          </span>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <label class="form-label">Description</label>
      <div class="input-group">
        <input
          type="number"
          min="0"
          class="form-control"
          [ngClass]="{
            'invalid-input':
              form.get('amount')?.invalid && form.get('amount')?.touched,
          }"
          formControlName="amount" />
        <select class="form-select" formControlName="amountUnit">
          <option value="USD">USD</option>
          <option value="percent">percent</option>
        </select>
        <span class="input-group-text">per</span>
        <select class="form-select" formControlName="applyPer">
          <option value="ticket">ticket</option>
          <option value="transaction">transaction</option>
        </select>
        <span class="input-group-text">up to</span>
        <input
          type="number"
          min="0"
          class="form-control"
          [ngClass]="{
            'invalid-input':
              form.get('capAmount')?.invalid && form.get('capAmount')?.touched,
          }"
          formControlName="capAmount" />
        <select class="form-select" formControlName="capAmountUnit">
          <option
            *ngIf="form.get('applyPer')?.value !== 'transaction'"
            value="tickets">
            tickets
          </option>
          <option value="USD">USD</option>
        </select>
      </div>
      <div class="form-text">
        {{ getDescriptionPreview() }}
      </div>
      <span
        class="small error-color"
        *ngIf="form.get('amount')?.invalid && form.get('amount')?.touched">
        Amount must be greater than or equal to 0
      </span>
      <span
        class="small error-color"
        *ngIf="
          form.get('capAmount')?.invalid && form.get('capAmount')?.touched
        ">
        Cap amount must be greater than or equal to 0
      </span>
    </div>
  </form>
</div>
<div class="btns-containers">
  <button class="default-4" (click)="dismissModal()">Cancel</button>
  <button
    class="default-1"
    [class.disabled-button]="!form.valid || isLoading"
    type="button"
    (click)="save()"
    [disabled]="!form.valid || isLoading">
    Save
  </button>
</div>
